import React from "react";
import styles from "./matriceDiCorrelazione1y.module.scss";
import { useTranslation } from "react-i18next";

const MatriceDiCorrelazione1y = ({ dataObject }) => {
  const { t } = useTranslation();
  if (!dataObject) return null;

  const { data, isin, legend } = dataObject;

  const nrIsin = Object.keys(data).length;
  const matrixArray = [];
  const isinNameArr = [];
  for (let i = 1; i <= nrIsin; i++) {
    const isinName = isin[i];
    isinNameArr.push(legend[i]);
    const isinObjValues = data[isinName];
    const colArray = [];
    for (let j = 1; j <= nrIsin; j++) {
      colArray.push(isinObjValues[isin[j]]);
    }
    matrixArray.push(colArray);
  }

  const size = nrIsin;
  const rows = Array.from({ length: size - 1 }, (_, i) => i + 2);
  const cols = Array.from({ length: size - 1 }, (_, i) => i + 1);

  const half = Math.ceil(isinNameArr.length / 2);
  const col1 = isinNameArr.slice(0, half);
  const col2 = isinNameArr.slice(half);
  return (
    <div className={styles.container}>
      <div
        className={styles.grid}
        style={{
          gridTemplateColumns: `minmax(70px, max-content) repeat(${cols.length}, 1fr)`,
          gridTemplateRows: `max-content repeat(${rows.length}, 1fr)`,
        }}
      >
        <div className={styles.headerCellH}>N</div>
        {cols.map((col) => (
          <div key={`col-${col}`} className={styles.headerCellH}>
            {col}
          </div>
        ))}

        {rows.map((row) => (
          <React.Fragment key={`row-${row}`}>
            <div className={styles.headerCellV}>{row}</div>
            {cols.map((col) => (
              <div key={`cell-${row}-${col}`} className={styles.cell}>
                {col < row ? (
                  <span className={styles.dot}>
                    {matrixArray[col - 1][row - 1]}
                  </span>
                ) : null}
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
      <div className={styles.legendaContainer}>
        <div className={styles.column}>
          {col1.map((isinName, index) => (
            <div key={index} className={styles.legendaItem}>
              {index + 1} - {isinName}
            </div>
          ))}
        </div>
        <div className={styles.column}>
          {col2.map((isinName, index) => (
            <div key={index + col1.length} className={styles.legendaItem}>
              {index + 1 + col1.length} - {isinName}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MatriceDiCorrelazione1y;
